<template>
  <li>
    <div class="imgCard line3">
      <div class="img">
        <img :data-src="menu.full_image_path" class="lazyload" />
      </div>
      <div class="text" @click="handleIsActive()">
        <h3 class="title">{{ menu.name }}</h3>
        <div class="subtitle">{{ menu.display_price }}</div>
        <div v-html="menu.explanation" class="content"></div>
      </div>
    </div>
    <Transition name="imgCardModal" @before-enter="beforeEnter" @after-leave="afterLeave">
      <div v-if="isActive" class="imgCardModal">
        <div class="box" v-click-outside="handleIsActive">
          <div class="img lazyload" :data-bg="imageStyle(menu.full_image_path)">
            <button class="close" @click="handleIsActive()"><img src="/assets/img/common/close--bg-white.svg" alt="close"></button>
          </div>
          <div class="text">
            <h3 class="title">{{ menu.name }}</h3>
            <div class="subtitle">{{ menu.display_price }}</div>
            <div class="content" v-html="menu.explanation"></div>
          </div>
        </div>
      </div>
    </Transition>
  </li>
</template>

<script>
import vClickOutside from 'click-outside-vue3'
export default {
  props: {
    menu: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      isActive: false,
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  mounted() {
    this.lazyLoad();
  },
  methods: {
    lazyLoad() {
      document.addEventListener('lazybeforeunveil', function(e) {
        let bg = e.target.getAttribute('data-bg');
        if (bg){
          e.target.style.backgroundImage = `url("${bg}")`;
        }
      });
    },
    imageStyle(url) {
      return url ?? null;
    },
    handleIsActive() {
      this.isActive = this.isActive ? false : true
    },
    beforeEnter() {
      document.body.style.overflow = "hidden";
    },
    afterLeave() {
      document.body.style.overflow = "";
    }
  }
}
</script>
